import { ControlValueAccessor } from '@angular/forms';
import { signal } from '@angular/core';

/**
 * Minimal ControlValueAccessor base for the shared form controls. Holds the
 * value + disabled state as signals and the registered callbacks, so subclasses
 * only render and call `setValue()`. Works with both `ngModel` and reactive forms.
 */
export abstract class BaseControl<T> implements ControlValueAccessor {
  protected readonly value = signal<T | null>(null);
  protected readonly disabled = signal(false);

  private onChange: (value: T | null) => void = () => {};
  protected onTouched: () => void = () => {};

  writeValue(value: T | null): void {
    this.value.set(value);
  }
  registerOnChange(fn: (value: T | null) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  /** Update value + notify the form. */
  protected setValue(value: T | null): void {
    this.value.set(value);
    this.onChange(value);
  }
}
